import { styled } from 'styled-components';

export const FooterContainer = styled.div`
  display: flex;
`;
export const StyledEmailLink = styled.a`
  margin-left: 7px;
`;
